// extracted by mini-css-extract-plugin
export default {"searchBoxContainer":"searchBoxContainer__WhnuLLoC","input":"input__AYdWq4ne","skeleton":"skeleton__CgVzMCxk"};